import { Stack, TextField } from '@mui/material';

import Form from 'components/Form';

import { IFormRegister } from '../type';

interface Props extends IFormRegister {
  disabled?: boolean;
}

function FocusDar({ register, disabled }: Props) {
  return (
    <Stack spacing={2}>
      <Form.Item label="Tập trung">
        <TextField
          // required
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('focus')}
        />
      </Form.Item>

      <Form.Item label="Thông tin">
        <TextField
          // required
          fullWidth
          multiline
          minRows={4}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('data')}
        />
      </Form.Item>

      <Form.Item label="Hành động">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('action')}
        />
      </Form.Item>

      <Form.Item label="Phản hồi">
        <TextField
          // required
          fullWidth
          multiline
          minRows={5}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('response')}
        />
      </Form.Item>
    </Stack>
  );
}

export default FocusDar;
